import { useState, useEffect, useRef } from "react";
import "../../assets/styles/local/MvpNewView.css";

import navigationIcon from "../../assets/icons/send.png";
import clipboard from "../../assets/icons/clipboard.png";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { myTaskToday } from "../../redux/actions/action";
import Header from "../../layouts/Header";
import Loader from "../../components/Dailogs/Loader";

const MvpNewView = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const initialRender = useRef(true);
  const userid = window.localStorage.getItem("userid");
  const primaryColor = window.localStorage.getItem("primarycolor");
  const taskToday = useSelector((state) => state.user.taskToday);
  const [todayTaskData, setTodayTaskData] = useState([]);
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    if (userid) {
      dispatch(myTaskToday(userid));
    }
  }, [userid, dispatch]);

  useEffect(() => {
    if (!initialRender.current) {
      if (taskToday !== null) {
        if (taskToday.status === true) {
          setTodayTaskData(taskToday?.data);
          setShowLoader(false);
        }
      }
    } else {
      initialRender.current = false;
    }
  }, [taskToday]);

  const handleRedirect = () => {
    if (selectedTaskId) {
      history.push(`/my-task/${selectedTaskId}`);
    }
  };

  const openModal = (taskId) => {
    setSelectedTaskId(taskId); // Set the clicked task ID
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const getInitials = (name) => {
    console.log("name====>", name);
    if (!name || name.length === 0 || typeof name !== "string") {
      return " ";
    }
    const hasSpace = name.includes(" ") && name.split(" ")[1]?.length > 0;
    if (hasSpace) {
      const initials = name
        .split(" ")
        .map((word) => word.charAt(0))
        .join("")
        .toUpperCase();

      return initials;
    } else {
      return name.slice(0, 2).toUpperCase();
    }
  };

  return (
    <>
      <Header />
      {showLoader === true ? (
        <div
          className="text-center "
          style={{ color: "#003766", fontSize: "14px", fontWeight: "700" }}
        >
          <Loader />
        </div>
      ) : (
        <div className="mvp-new-view">
          <div className="ps-4">
            <p className="todayTask ">My Tasks</p>
          </div>
          {todayTaskData && todayTaskData.length > 0 ? (
            todayTaskData.map((task) => (
              <div
                key={task.taskid}
                className="task-card h-auto"
                style={{ minHeight: "60px" }}
                onClick={() => {
                  // openModal(task.taskid);
                  history.push(`/my-task/${task.taskid}`);
                }}
              >
                <div
                  className="priority-strip"
                  style={{
                    backgroundColor:
                      task.priority === "Low"
                        ? "#D2DCE9" // Green for LOW
                        : task.priority === "High"
                          ? "#F76767" // Red for HIGH
                          : "#95A7C6",
                  }}
                ></div>
                <div className="task-content gap-3">
                  <div className="text-content" style={{ minWidth: "150px" }}>
                    <div className="task-title">{task.taskname}</div>
                    {/* <div className="company-name">{task.companyName}</div> */}
                  </div>
                  <div className="task-avatars">
                    {task?.assigneedetail?.length > 3 ? (
                      <>
                        <div
                          className="task-card-image"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#00246A",
                            border: "none",
                            color: "#FFFFFF",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "bolder",
                          }}
                        >
                          +{task?.assigneedetail?.length - 3}
                        </div>
                        {task?.assigneedetail
                          ?.slice(0, 3)
                          .map((assignee, i) => {
                            const hasImageUrl =
                              assignee?.imageurl &&
                              assignee?.imageurl.length > 0;
                            return (
                              <div
                                key={`assignee-${i}`}
                                className="assignee-container"
                                style={{
                                  marginLeft: i === 0 ? 0 : "-8px",
                                }}
                              >
                                {hasImageUrl ? (
                                  <img
                                    alt=""
                                    className="task-card-image"
                                    src={assignee?.imageurl}
                                    style={{
                                      border: `2px solid ${primaryColor}`,
                                      marginLeft: "-18px",
                                    }}
                                  />
                                ) : (
                                  <div
                                    style={{
                                      border: "2px solid white",
                                      backgroundColor: "#95A7C6",
                                      height: "38px",
                                      width: "38px",
                                      borderRadius: "50%",
                                      color: "white",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      fontWeight: "500",
                                      marginLeft: "-18px",
                                    }}
                                  >
                                    {getInitials(assignee?.assigneeName)}
                                  </div>
                                )}
                              </div>
                            );
                          })}
                      </>
                    ) : (
                      task?.assigneedetail?.map((assignee, i) => {
                        const hasImageUrl =
                          assignee?.imageurl && assignee?.imageurl.length > 0;
                        return (
                          <div
                            key={`assignee-${i}`}
                            className="assignee-container"
                            style={{
                              marginLeft: i === 0 ? 0 : "-8px",
                            }}
                          >
                            {hasImageUrl ? (
                              <img
                                alt=""
                                className="task-card-image"
                                src={assignee?.imageurl}
                                style={{
                                  border: `2px solid ${primaryColor}`,
                                }}
                              />
                            ) : (
                              <div
                                style={{
                                  border: "2px solid white",
                                  backgroundColor: "#95A7C6",
                                  height: "38px",
                                  width: "38px",
                                  borderRadius: "50%",
                                  color: "white",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontWeight: "500",
                                  marginLeft: "-18px",
                                }}
                              >
                                {getInitials(assignee?.assigneeName)}
                              </div>
                            )}
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="no-tasks-message">
              No tasks available for today.
            </div>
          )}

          {isModalOpen && (
            <>
              <div className="blurred-background" onClick={closeModal}></div>
              <div className="task_modal">
                <div className="mvp-modal-content">
                  <button className="close-btn" onClick={closeModal}>
                    &times;
                  </button>
                  <p className="modal-text">What would you like to do?</p>
                  <button className="navigation-btn">
                    <img
                      src={navigationIcon}
                      alt="icon"
                      className="button-icon"
                    />
                    Start Navigating
                  </button>
                  <button className="action-btn" onClick={handleRedirect}>
                    <img src={clipboard} alt="icon" className="button-icon" />
                    See Task details...
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default MvpNewView;
